<sbb-popup
  [rendered]="overlayVisible"
  [map]="map"
  [template]="overlayTemplate"
  [templateContext]="overlayFeatures"
  [withPaginator]="true"
  [position]="overlayPosition"
  (closeClicked)="onOverlayClosed()"
  (mouseEvent)="onOverlayMouseEvent($event)"
  *ngIf="overlayIsPopup"
>
</sbb-popup>

<sbb-teaser
  [rendered]="overlayVisible"
  [template]="overlayTemplate"
  [templateContext]="overlayFeatures"
  [withPaginator]="true"
  (closeClicked)="onOverlayClosed()"
  (mouseEvent)="onOverlayMouseEvent($event)"
  *ngIf="!overlayIsPopup"
>
</sbb-teaser>
